import { Component } from '@angular/core';
import { AngularFireAuth } from 'angularfire2/auth';
import { auth } from 'firebase';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html'
})
export class LoginComponent {
  constructor(public afAuth: AngularFireAuth) {}
  login() {
    this.afAuth.auth
      .signInWithPopup(new auth.GoogleAuthProvider())
      .then(user => {
        if (user.user.displayName === 'Bryan Huang') {
          localStorage.setItem('dffUser', 'Brian Huang');
        } else if (user.user.displayName === 'Bretton McIlrath (Bretton_Mc)') {
          localStorage.setItem('dffUser', 'Bretton McIlrath');
        } else {
          localStorage.setItem('dffUser', user.user.displayName);
        }
        window.location.href = '/';
      });
  }
  logout() {
    this.afAuth.auth.signOut();
    localStorage.removeItem('dffUser');
  }
}
